/* tslint:disable */
/* eslint-disable */
/**
 * Payment Schedule API
 * API to manage payment schedules (échéances de paiement)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BreakdownGuaranteeDto } from './BreakdownGuaranteeDto';
import {
    BreakdownGuaranteeDtoFromJSON,
    BreakdownGuaranteeDtoFromJSONTyped,
    BreakdownGuaranteeDtoToJSON,
    BreakdownGuaranteeDtoToJSONTyped,
} from './BreakdownGuaranteeDto';
import type { PricingDto } from './PricingDto';
import {
    PricingDtoFromJSON,
    PricingDtoFromJSONTyped,
    PricingDtoToJSON,
    PricingDtoToJSONTyped,
} from './PricingDto';
import type { BreakdownBeneficiaryDto } from './BreakdownBeneficiaryDto';
import {
    BreakdownBeneficiaryDtoFromJSON,
    BreakdownBeneficiaryDtoFromJSONTyped,
    BreakdownBeneficiaryDtoToJSON,
    BreakdownBeneficiaryDtoToJSONTyped,
} from './BreakdownBeneficiaryDto';
import type { BreakdownDebtorDto } from './BreakdownDebtorDto';
import {
    BreakdownDebtorDtoFromJSON,
    BreakdownDebtorDtoFromJSONTyped,
    BreakdownDebtorDtoToJSON,
    BreakdownDebtorDtoToJSONTyped,
} from './BreakdownDebtorDto';
import type { BreakdownTotalByBeneficiaryDto } from './BreakdownTotalByBeneficiaryDto';
import {
    BreakdownTotalByBeneficiaryDtoFromJSON,
    BreakdownTotalByBeneficiaryDtoFromJSONTyped,
    BreakdownTotalByBeneficiaryDtoToJSON,
    BreakdownTotalByBeneficiaryDtoToJSONTyped,
} from './BreakdownTotalByBeneficiaryDto';
import type { BreakdownFeeDto } from './BreakdownFeeDto';
import {
    BreakdownFeeDtoFromJSON,
    BreakdownFeeDtoFromJSONTyped,
    BreakdownFeeDtoToJSON,
    BreakdownFeeDtoToJSONTyped,
} from './BreakdownFeeDto';

/**
 * Full breakdown of a payment schedule showing guarantees, fees, and totals by beneficiary
 * @export
 * @interface GetPaymentBreakdownResponse
 */
export interface GetPaymentBreakdownResponse {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentBreakdownResponse
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentBreakdownResponse
     */
    instalmentNumber: number;
    /**
     * 
     * @type {Date}
     * @memberof GetPaymentBreakdownResponse
     */
    dueDate: Date;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentBreakdownResponse
     */
    status: string;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentBreakdownResponse
     */
    totalAmount: number;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentBreakdownResponse
     */
    purePremiumAmount: number;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentBreakdownResponse
     */
    commissionsAmount: number;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentBreakdownResponse
     */
    taxAmount: number;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentBreakdownResponse
     */
    feesAmount: number;
    /**
     * 
     * @type {Date}
     * @memberof GetPaymentBreakdownResponse
     */
    paymentDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentBreakdownResponse
     */
    directDebitKey?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentBreakdownResponse
     */
    uniqueReference?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentBreakdownResponse
     */
    rum?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentBreakdownResponse
     */
    debtorIban?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentBreakdownResponse
     */
    creditorIban?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentBreakdownResponse
     */
    mandateSignatureDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentBreakdownResponse
     */
    contractNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentBreakdownResponse
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentBreakdownResponse
     */
    receiptNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentBreakdownResponse
     */
    paymentFrequency: string;
    /**
     * 
     * @type {BreakdownDebtorDto}
     * @memberof GetPaymentBreakdownResponse
     */
    debtor: BreakdownDebtorDto;
    /**
     * 
     * @type {BreakdownBeneficiaryDto}
     * @memberof GetPaymentBreakdownResponse
     */
    mainBeneficiary: BreakdownBeneficiaryDto;
    /**
     * 
     * @type {Array<BreakdownGuaranteeDto>}
     * @memberof GetPaymentBreakdownResponse
     */
    guarantees: Array<BreakdownGuaranteeDto>;
    /**
     * 
     * @type {Array<BreakdownFeeDto>}
     * @memberof GetPaymentBreakdownResponse
     */
    fees: Array<BreakdownFeeDto>;
    /**
     * 
     * @type {Array<BreakdownTotalByBeneficiaryDto>}
     * @memberof GetPaymentBreakdownResponse
     */
    totalsByBeneficiary: Array<BreakdownTotalByBeneficiaryDto>;
    /**
     * 
     * @type {PricingDto}
     * @memberof GetPaymentBreakdownResponse
     */
    totalGuarantees: PricingDto;
    /**
     * 
     * @type {PricingDto}
     * @memberof GetPaymentBreakdownResponse
     */
    totalFees: PricingDto;
    /**
     * 
     * @type {PricingDto}
     * @memberof GetPaymentBreakdownResponse
     */
    total: PricingDto;
}

/**
 * Check if a given object implements the GetPaymentBreakdownResponse interface.
 */
export function instanceOfGetPaymentBreakdownResponse(value: object): value is GetPaymentBreakdownResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('instalmentNumber' in value) || value['instalmentNumber'] === undefined) return false;
    if (!('dueDate' in value) || value['dueDate'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('totalAmount' in value) || value['totalAmount'] === undefined) return false;
    if (!('purePremiumAmount' in value) || value['purePremiumAmount'] === undefined) return false;
    if (!('commissionsAmount' in value) || value['commissionsAmount'] === undefined) return false;
    if (!('taxAmount' in value) || value['taxAmount'] === undefined) return false;
    if (!('feesAmount' in value) || value['feesAmount'] === undefined) return false;
    if (!('paymentFrequency' in value) || value['paymentFrequency'] === undefined) return false;
    if (!('debtor' in value) || value['debtor'] === undefined) return false;
    if (!('mainBeneficiary' in value) || value['mainBeneficiary'] === undefined) return false;
    if (!('guarantees' in value) || value['guarantees'] === undefined) return false;
    if (!('fees' in value) || value['fees'] === undefined) return false;
    if (!('totalsByBeneficiary' in value) || value['totalsByBeneficiary'] === undefined) return false;
    if (!('totalGuarantees' in value) || value['totalGuarantees'] === undefined) return false;
    if (!('totalFees' in value) || value['totalFees'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function GetPaymentBreakdownResponseFromJSON(json: any): GetPaymentBreakdownResponse {
    return GetPaymentBreakdownResponseFromJSONTyped(json, false);
}

export function GetPaymentBreakdownResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPaymentBreakdownResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'instalmentNumber': json['instalmentNumber'],
        'dueDate': (new Date(json['dueDate'])),
        'status': json['status'],
        'totalAmount': json['totalAmount'],
        'purePremiumAmount': json['purePremiumAmount'],
        'commissionsAmount': json['commissionsAmount'],
        'taxAmount': json['taxAmount'],
        'feesAmount': json['feesAmount'],
        'paymentDate': json['paymentDate'] == null ? undefined : (new Date(json['paymentDate'])),
        'directDebitKey': json['directDebitKey'] == null ? undefined : json['directDebitKey'],
        'uniqueReference': json['uniqueReference'] == null ? undefined : json['uniqueReference'],
        'rum': json['rum'] == null ? undefined : json['rum'],
        'debtorIban': json['debtorIban'] == null ? undefined : json['debtorIban'],
        'creditorIban': json['creditorIban'] == null ? undefined : json['creditorIban'],
        'mandateSignatureDate': json['mandateSignatureDate'] == null ? undefined : json['mandateSignatureDate'],
        'contractNumber': json['contractNumber'] == null ? undefined : json['contractNumber'],
        'productName': json['productName'] == null ? undefined : json['productName'],
        'receiptNumber': json['receiptNumber'] == null ? undefined : json['receiptNumber'],
        'paymentFrequency': json['paymentFrequency'],
        'debtor': BreakdownDebtorDtoFromJSON(json['debtor']),
        'mainBeneficiary': BreakdownBeneficiaryDtoFromJSON(json['mainBeneficiary']),
        'guarantees': ((json['guarantees'] as Array<any>).map(BreakdownGuaranteeDtoFromJSON)),
        'fees': ((json['fees'] as Array<any>).map(BreakdownFeeDtoFromJSON)),
        'totalsByBeneficiary': ((json['totalsByBeneficiary'] as Array<any>).map(BreakdownTotalByBeneficiaryDtoFromJSON)),
        'totalGuarantees': PricingDtoFromJSON(json['totalGuarantees']),
        'totalFees': PricingDtoFromJSON(json['totalFees']),
        'total': PricingDtoFromJSON(json['total']),
    };
}

export function GetPaymentBreakdownResponseToJSON(json: any): GetPaymentBreakdownResponse {
    return GetPaymentBreakdownResponseToJSONTyped(json, false);
}

export function GetPaymentBreakdownResponseToJSONTyped(value?: GetPaymentBreakdownResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'instalmentNumber': value['instalmentNumber'],
        'dueDate': ((value['dueDate']).toISOString()),
        'status': value['status'],
        'totalAmount': value['totalAmount'],
        'purePremiumAmount': value['purePremiumAmount'],
        'commissionsAmount': value['commissionsAmount'],
        'taxAmount': value['taxAmount'],
        'feesAmount': value['feesAmount'],
        'paymentDate': value['paymentDate'] == null ? undefined : ((value['paymentDate'] as any).toISOString()),
        'directDebitKey': value['directDebitKey'],
        'uniqueReference': value['uniqueReference'],
        'rum': value['rum'],
        'debtorIban': value['debtorIban'],
        'creditorIban': value['creditorIban'],
        'mandateSignatureDate': value['mandateSignatureDate'],
        'contractNumber': value['contractNumber'],
        'productName': value['productName'],
        'receiptNumber': value['receiptNumber'],
        'paymentFrequency': value['paymentFrequency'],
        'debtor': BreakdownDebtorDtoToJSON(value['debtor']),
        'mainBeneficiary': BreakdownBeneficiaryDtoToJSON(value['mainBeneficiary']),
        'guarantees': ((value['guarantees'] as Array<any>).map(BreakdownGuaranteeDtoToJSON)),
        'fees': ((value['fees'] as Array<any>).map(BreakdownFeeDtoToJSON)),
        'totalsByBeneficiary': ((value['totalsByBeneficiary'] as Array<any>).map(BreakdownTotalByBeneficiaryDtoToJSON)),
        'totalGuarantees': PricingDtoToJSON(value['totalGuarantees']),
        'totalFees': PricingDtoToJSON(value['totalFees']),
        'total': PricingDtoToJSON(value['total']),
    };
}

